import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { GeneralInfoState } from "@reducers/types/HRM/general-info-state";

import {
  createGeneralInfoRequest,
  getGeneralInfoRequest,
  updateGeneralInfoRequest,
} from "@actions/HRM/employee/general-info-actions";
import { getGeneralInfoState } from "@selectors/HRM/employee/general-info-selector";

import { useAppSelector } from "@helpers/redux";
import { GeneralInfoType } from "@type/HRM/general-info";

interface UseGeneralInfoResponseType {
  addGeneralInfo: (newGeneralInfo: GeneralInfoType) => void;
  generalInfo: GeneralInfoType;
  changeGeneralInfo: (newGeneralInfo: GeneralInfoType) => void;
  getGeneralInfoRequestOngoing: boolean;
  createGeneralInfoRequestOngoing: boolean;
  createGeneralInfoSuccess: boolean;
  createGeneralInfoFailed: boolean;
  createGeneralInfoError: any;
  updateGeneralInfoRequestOngoing: boolean;
  updateGeneralInfoSuccess: boolean;
  updateGeneralInfoFailed: boolean;
}

export const useGeneralInfo = (
  id: number | null,
): UseGeneralInfoResponseType => {
  const dispatch = useDispatch();

  const {
    data,
    createGeneralInfoRequestOngoing,
    createGeneralInfoSuccess,
    createGeneralInfoError,
    createGeneralInfoFailed,
    getGeneralInfoRequestOngoing,
    updateGeneralInfoRequestOngoing,
    updateGeneralInfoSuccess,
    updateGeneralInfoFailed,
  } = useAppSelector<GeneralInfoState>(getGeneralInfoState);

  //GET
  useEffect(() => {
    if (id) dispatch(getGeneralInfoRequest(id)); // Here "id" is the employee id
  }, [dispatch, id]);
  const generalInfo = data as GeneralInfoType;

  //CREATE NEW GENERAL INFO
  const addGeneralInfo = (newGeneralInfo: GeneralInfoType) =>
    dispatch(createGeneralInfoRequest(newGeneralInfo));

  //UPDATE GENERAL INFO
  const changeGeneralInfo = (updateGeneralInfo: GeneralInfoType) =>
    dispatch(
      updateGeneralInfoRequest({
        employeeID: id,
        ...updateGeneralInfo,
      }),
    );

  return {
    addGeneralInfo,
    generalInfo,
    changeGeneralInfo,
    createGeneralInfoRequestOngoing,
    createGeneralInfoSuccess,
    createGeneralInfoFailed,
    createGeneralInfoError,
    getGeneralInfoRequestOngoing,
    updateGeneralInfoRequestOngoing,
    updateGeneralInfoSuccess,
    updateGeneralInfoFailed,
  };
};
